import { formatMoney, formatNumber, KpiTile, MoneyText, type KpiDetail } from '@platform/design-system';
import type { TypedClient } from '@platform/openapi';
import { useTenantDetail } from '../catalog/useCatalogQueries.ts';
import { usePageContext } from '../usePageContext.ts';
import { useStockOverview, type StockOverview, type StockScope } from './stock.ts';

const EVERY_COMPANY = null;

type Totals = StockOverview['totals'];

export type StockValueTileProps = { api: TypedClient; scope: StockScope };

export const StockValueTile = ({ api, scope }: StockValueTileProps) => {
  const { t, locale } = usePageContext();
  const totals = useStockOverview(api, EVERY_COMPANY, scope).data?.totals;
  const currency = useTenantDetail(api).data?.currency;
  const detailsOf = (stock: Totals, money: string): KpiDetail[] => [
    { label: t('stockValue.units'), value: formatNumber(stock.onHand, locale) },
    ...(stock.value === null
      ? []
      : [
          {
            label: t('stockValue.cost'),
            value: formatMoney({ amount: stock.value, currency: money }, locale),
          },
        ]),
  ];
  return (
    <KpiTile
      label={t('stockValue.title')}
      loading={totals === undefined || currency === undefined}
      value={
        totals === undefined || currency === undefined ? undefined : (
          <MoneyText money={{ amount: totals.saleValue, currency }} locale={locale} />
        )
      }
      hint={t('stockValue.hint')}
      details={totals === undefined || currency === undefined ? undefined : detailsOf(totals, currency)}
    />
  );
};
